@if (versionInfo()?.ghRunNumber) {
  <div
    [class.version-info]="applyCustomClass()"
    [class.fw-300]="applyCustomClass()"
    class="bg-white bg-opacity-25 fs-12 px-2 rounded-2 py-0"
  >
    Build #{{ versionInfo()?.ghRunNumber }}
  </div>
}

<!-- <div [class.version-info]="applyCustomClass()"  [class.fw-300]="applyCustomClass()" class="bg-white bg-opacity-25 fs-12 px-2 rounded-2 py-0">Build 56</div> -->
